import { Avatar, Box, CircularProgress, List, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material'
import type React from 'react'
import { useState } from 'react'
import { type CommentParentType, type CommentModel } from '../../../models/Comment'
import './CommentField.css'
import { useTagging } from '../../../hooks/use-comments'

interface CommentFieldProps {
  comment?: CommentModel
  disabled?: boolean
  parentId: number
  parentType: CommentParentType
  contentEditableRef: React.RefObject<HTMLDivElement>
  setContent: React.Dispatch<React.SetStateAction<string>>
}

export const CommentField = (props: CommentFieldProps): JSX.Element => {
  const [isFocused, setIsFocused] = useState(false)

  const { loading, suggestions, tagging, handleSuggestionClick, handleInput } = useTagging(props.parentId, props.parentType, props.contentEditableRef, props.setContent)

  return (
    <Box>
      <div
        data-testid='commentField'
        contentEditable={props.disabled !== true}
        ref={props.contentEditableRef}
        onInput={handleInput}
        onFocus={() => { setIsFocused(true) }}
        onBlur={() => { if (!tagging) setIsFocused(false) }}
        style={{
          padding: '20px',
          borderRadius: '12px',
          backgroundColor: 'var(--white)',
          border: '1px solid var(--border)',
          minHeight: isFocused ? '80px' : '40px',
          transition: 'min-height 0.3s ease'
        }}
        id='commentField'
        data-placeholder="Please share your thoughts..."
      />

      {tagging && <List dense={true} sx={{ backgroundColor: 'var(--white)', border: '1px solid var(--border)', borderRadius: '12px' }}>
        {loading && <CircularProgress />}
        {!loading && suggestions.length === 0 && <Typography variant='body1' sx={{ p: '8px' }}>No users found matching the search criteria</Typography>}
        {!loading && suggestions.length > 0 && suggestions.map(user => (
          <ListItemButton
            data-testid="userSuggestion"
            key={user.id}
            onClick={() => { handleSuggestionClick(user) }}
            sx={{ ':hover': { backgroundColor: 'var(--blue-50)' } }}
          >
            <ListItemAvatar>
              <Avatar />
            </ListItemAvatar>

            <ListItemText primary={`${user.firstName} ${user.lastName}`} secondary={user.email} />
          </ListItemButton>
        ))}
      </List>}
    </Box>
  )
}
